import { render, staticRenderFns } from "./ChangeScopeDialog.vue?vue&type=template&id=1f447402&scoped=true"
import script from "./ChangeScopeDialog.vue?vue&type=script&lang=js"
export * from "./ChangeScopeDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeScopeDialog.vue?vue&type=style&index=0&id=1f447402&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f447402",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
